import { IonButton, IonButtons } from "@ionic/react"

export const UploadButton = ({id_doc, userId, text}:any) => {
  return (
    <IonButton href={`/app/supervision/colaborador/subir-documento/${id_doc}/${userId}`}>{text}</IonButton>
  )
}